export const seoConfig = {
  baseUrl: 'https://menu-images.com',
  siteName: 'Menu AI',
  defaultImage: 'https://menu-images.com/image_compressed.png',
  twitterHandle: '@jordibosch20',
  twitterDomain: 'menu-images.com',
  locale: 'en_US',
};

export const buildSeoUrl = path => `${seoConfig.baseUrl}${path}`;
